import * as tslib_1 from "tslib";
import { GalleryStore } from './GalleryStore';
import { getStyleParamsWithDefaults } from '@wix/wixstores-client-common-components/dist/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
import { ProductsService } from '../services/ProductsService';
import { getStyleParamsWithDefaultsFunc } from '../getStyleParamsWithDefaultsFunc';
import { MAX_COLS, MAX_ROWS } from '../constants';
export function getInitialProductsCountToFetch(isMobile, rows, cols) {
    if (rows === void 0) { rows = 6; }
    if (cols === void 0) { cols = 4; }
    if (isMobile) {
        return 10;
    }
    return rows * cols;
}
export function galleryController(controllerFactoryConfig) {
    var _this = this;
    var galleryStore;
    var compId = controllerFactoryConfig.compId, config = controllerFactoryConfig.config, setProps = controllerFactoryConfig.setProps, factoryContext = controllerFactoryConfig.context, type = controllerFactoryConfig.type, reportError = controllerFactoryConfig.reportError;
    var styleParams = config.style.styleParams;
    return {
        pageReady: function () {
            var styleParamsWithDefaults = getStyleParamsWithDefaults(styleParams, function () {
                return getStyleParamsWithDefaultsFunc({ style: { styleParams: styleParams }, dimensions: undefined });
            });
            var isMobile = factoryContext.siteStore.isMobile();
            var initialProductsCount = getInitialProductsCountToFetch(isMobile, styleParamsWithDefaults.numbers.galleryRows, styleParamsWithDefaults.numbers.galleryColumns);
            if (factoryContext.siteStore.isEditorMode()) {
                initialProductsCount = MAX_ROWS * MAX_COLS;
            }
            var productsService = new ProductsService(factoryContext.siteStore, initialProductsCount, 'Grid Gallery');
            galleryStore = new GalleryStore(styleParamsWithDefaults, config, setProps, factoryContext.siteStore, productsService, compId, type, reportError);
            return galleryStore.setInitialState().catch(reportError);
        },
        updateConfig: function (_$w, _a) {
            var newStyleParams = _a.style.styleParams, newPublicData = _a.publicData;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, galleryStore.updateState(newStyleParams, newPublicData)];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    };
}
//# sourceMappingURL=galleryController.js.map